export default __webpack_public_path__ + "static/media/src_jquery_desktop_1.69eb19af.jpg";